import { PieChart, PieChartProps } from '../../../../renderers/pie-chart/pie-chart.component';
import { PUDO_TRANSACTION_VOLUME_BY_SPOT_DONUT_CHART_DEFINITION } from './pudo-transaction-volume-by-spot-donut-chart.definition';
import { PUDO_TRANSACTION_VOLUME_BY_SPOT_DONUT_CHART_MOCK_DATA } from './pudo-transaction-volume-by-spot-donut-chart.mock';

export const PudoTransactionVolumeBySpotDonutChart = (props: PieChartProps) => (
    <PieChart
        {...props}
        variant='donut'
        showSliceValues
    />
);

PudoTransactionVolumeBySpotDonutChart.definition = PUDO_TRANSACTION_VOLUME_BY_SPOT_DONUT_CHART_DEFINITION;
PudoTransactionVolumeBySpotDonutChart.mockData = PUDO_TRANSACTION_VOLUME_BY_SPOT_DONUT_CHART_MOCK_DATA;
